export default __webpack_public_path__ + "static/media/minamt-icon.fef1e69d.svg";